import React, { Component } from 'react'
import { Provider } from 'react-redux'
import { BrowserRouter } from 'react-router-dom'
import { MediaQueryProvider } from 'react-media-query-hoc'
import browserUpdate from 'browser-update'
import ErrorBoundary from './components/ErrorBoundary'
import AppRoutes from './routes/AppRoutes'
import store from './store/configureStore'
import { recuperarAmbiente, descartarAmbiente } from './actions/ambienteActions'
import { configureTheme } from './RootStyles'
import CssBaseline from '@mui/material/CssBaseline'
import { ThemeProvider } from '@mui/material'

const isEdge = window.navigator.userAgent.indexOf('Edg') !== -1
const browserOutdatedMsg =
  '<b>Seu navegador da web ({brow_name}) está desatualizado.</b> ' +
  '<a href="/updatebrowser" target="_blank" style="text-decoration: none">Atualize seu navegador</a> para ter mais segurança e velocidade, além da melhor experiência neste sistema.'
const browserNotSupportedMsg =
  '<b>Seu navegador da web ({brow_name}) não é compatível com este sistema.</b> ' +
  'Instale o Chrome ou Firefox para ter mais segurança e velocidade, além da melhor experiência neste sistema.'
const isUpdateBrowser = window.location.pathname === '/updatebrowser'
const customQueries = {
  xs: 'screen and (min-width: 0px) and (max-width: 599px)',
  sm: 'screen and (min-width: 600px) and (max-width: 959px)',
  md: 'screen and (min-width: 960px) and (max-width: 1279px)',
  lg: 'screen and (min-width: 1280px) and (max-width: 1919px)',
  xl: 'screen and (min-width: 1920px)'
}

export class Root extends Component {
  constructor(props) {
    super(props)
    this.state = {
      blocked: false
    }
  }

  componentDidMount() {
    store.dispatch(recuperarAmbiente())
    if (!isUpdateBrowser) {
      browserUpdate({
        required: {
          c: '71.0.3578.80',
          f: 52,
          e: 9999,
          i: 11,
          s: 10
        },
        l: 'pt_BR',
        text: isEdge ? browserNotSupportedMsg : browserOutdatedMsg,
        test: false,
        reminder: 0,
        noclose: true,
        no_permanent_hide: true,
        onshow: (infos) => {
          console.log(infos)
          this.setState({ blocked: true })
        }
      })
    }
  }

  componentWillUnmount() {
    store.dispatch(descartarAmbiente())
  }

  render() {
    const { blocked } = this.state
    return (
      <ThemeProvider theme={configureTheme()}>
        <CssBaseline />
        <ErrorBoundary>
          <Provider store={store}>
            <BrowserRouter>
              <MediaQueryProvider queries={customQueries}>
                {blocked ? <div /> : <AppRoutes />}
              </MediaQueryProvider>
            </BrowserRouter>
          </Provider>
        </ErrorBoundary>
      </ThemeProvider>
    )
  }
}

export default Root
